<!--  -->
<template>
  <div class="content">
    <div class="ban">
      <img src="http://www.hitaledu.com/img/new.png" alt="湖南生易圈教育咨询有限公司" />
    </div>
    <!--新闻详情 -->
    <div class="info" v-if="show">
      <div class="card">
        <el-breadcrumb class="nav" separator="/">
          <el-breadcrumb-item
            ><a class="color" href="#" @click="topUrl(0, '/')"
              >首页</a
            ></el-breadcrumb-item
          >
          <el-breadcrumb-item
            ><a class="color" href="#" @click="topUrl(2, '/New')">新闻资讯</a>
          </el-breadcrumb-item>
          <el-breadcrumb-item
            ><a class="color" style="color: #1c75ff" href="#"
              >{{ data[0].titel }}
            </a></el-breadcrumb-item
          >
        </el-breadcrumb>
        <div class="header">
          <div class="title">
            {{ data[0].titel }}
          </div>
          <div class="time">发布时间：{{ data[0].create_time }}</div>
        </div>
        <!-- html -->
        <div class="html" v-html="data[0].content1"></div>
        <div class="fot">
          <div class="left" @click="up">
            上一篇：{{ data[0].on_title == "" ? "没有了" : data[0].on_title }}
          </div>
          <div class="left" @click="dowm">
            下一篇：{{
              data[0].under_title == "" ? "没有了" : data[0].under_title
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      id: "",
      data: [],
      show: false,
      loading: "",
      content:
        '<strong style="margin: 0px; padding: 0px; max-width: 100%; box-sizing: border-box !important; overflow-wrap: break-word !important;">01</strong>',
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 加载
    openFullScreen2() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
    },
    //跳转
    topUrl(index, url) {
      this.$router.push(url);
      this.$store.state.current = index;
      this.current = index;
      localStorage.setItem("current", this.current);
    },
    // 上一页
    up() {
      if (this.data[0].on_page != 0) {
        this.getData(this.data[0].on_page);
      }
    },
    // 下一页
    dowm() {
      if (this.data[0].under_page != 0) {
        this.getData(this.data[0].under_page);
      }
    },
    // 获取数据
    getData(e) {
      this.$http
        .get("http://www.hitaledu.com/admin/news/newsListJson&id=" + e)
        .then((response) => {
          if (response.data.code == 0) {
            this.data = response.data.data;
            this.show = true;
            this.loading.close();
          } else {
            this.$message({
              message: response.data.msg,
              type: "error",
            });
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.openFullScreen2();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // 取到路由带过来的参数
    this.id = this.$route.query.id;
    this.getData(this.id);
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="less">
// ban
.ban {
  img {
    width: 100%;
  }
}
.nav {
  padding: 20px 0;
}
.color {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #808080;
}
.header {
  padding-top: 40px;
  text-align: center;
  border-bottom: 1px solid #f2eded;
  .title {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    padding: 0 5px;
  }
  .time {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: #999999;
    line-height: 40px;
  }
}
.html {
  padding: 20px 10px;
  line-height: 50px;
}
.fot {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  padding: 16px 0;
  cursor: pointer;
}
.left:hover {
  color: #1c75ff;
}
</style>